import * as React from 'react'

function SvgBs(props) {
	return (
		<svg viewBox="0 0 600 300" width="1em" height="1em" {...props}>
			<path fill="#00abc9" d="M0 0h600v300H0z" />
			<path fill="#fae042" d="M0 100h600v100H0z" />
			<path d="M0 0v300l259.808-150z" />
		</svg>
	)
}

export default SvgBs
